// angular
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// bootstrap
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

// kendo
import { GridModule } from "@progress/kendo-angular-grid";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { PanelBarModule } from "@progress/kendo-angular-layout";
import { DialogModule } from '@progress/kendo-angular-dialog';

// app modules
import { ServiceBusRoutingModule } from "./service-bus-routing.module";

// app components
import { ServiceBusComponent } from "./service-bus.component";
import { MessagesComponent } from "./messages/messages.component";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { QueuesComponent } from './queues/queues.component';
import { TopicsComponent } from './topics/topics.component';
import { SubscriptionsComponent } from './subscriptions/subscriptions.component';
import { QueueComponent } from './queue/queue.component';
import { MessageComponent } from './message/message.component';
import { SubscriptionComponent } from './subscription/subscription.component';


@NgModule({
  declarations: [ServiceBusComponent, MessagesComponent, QueuesComponent, TopicsComponent, SubscriptionsComponent, QueueComponent, MessageComponent, SubscriptionComponent],
  imports: [
    CommonModule,
    ServiceBusRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    GridModule,
    DialogModule,
    DropDownsModule,
    PanelBarModule,
    FontAwesomeModule
  ],
})
export class ServiceBusModule {}
